module.exports = __webpack_public_path__ + "img/products-fabrixapi-thumbnail.9d03a8f4.jpg";